// Shared by the new-store, edit-store and settings pages. The value is stored
// verbatim in stores.currency and printed in front of amounts on the wallet
// pass and in the scanner, so existing values must never change spelling.
// Labels lead with the ISO code; the part in brackets is what the pass prints,
// shown only when it differs from the code.

export const CURRENCY_OPTIONS = [
  { value: "€", label: "EUR (€)" },
  { value: "$", label: "USD ($)" },
  { value: "£", label: "GBP (£)" },
  { value: "AED", label: "AED" },
  { value: "CHF", label: "CHF" },
  { value: "S$", label: "SGD (S$)" },
  { value: "PLN", label: "PLN" },
  { value: "DKK", label: "DKK" },
];

// Some stores carry a currency set by hand in the database (prod has "Zł").
// Without its own option the <select> displays the first entry instead, and
// touching the field silently switches the store to €.
export const currencyOptionsFor = (current) =>
  !current || CURRENCY_OPTIONS.some((option) => option.value === current)
    ? CURRENCY_OPTIONS
    : [...CURRENCY_OPTIONS, { value: current, label: current }];
